var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"welcome-btn",attrs:{"x-large":"","rounded":"","width":"200","id":"enter"},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.$t("action.enter"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }